<template>
    <v-btn
        class="button-primary-color"
        rounded
        :small="$vuetify.breakpoint.smAndDown && allowSmall"
        aria-disabled="false"
        tabindex="0"
        :aria-label="$t('base.previous')"
        data-testid="previous"
        @click="previousStep()"
    >
        <v-icon
            small
            class="mr-2"
            v-text="'fas fa-arrow-left'" />
        <span>{{ $t('base.previous') }}</span>
    </v-btn>
</template>

<script>
export default {
    props: {
        allowSmall: { type: Boolean, required: false, default: false }
    },
    methods: {
        /**
         * Emits previous step event for parent component
         */
        previousStep() {
            this.$emit('previousStep');
        },
    },
};
</script>

<style lang="scss" scoped>
</style>
